import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LocationMasterRoutingModule } from './location-master-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MaterialModule } from 'app/material.module';
import { SharedModule } from 'app/shared/shared.module';
import { WebcamModule } from 'ngx-webcam';
import { CityMasterComponent } from './city-master/city-master.component';
import { CountryMasterComponent } from './country-master/country-master.component';
import { StateMasterComponent } from './state-master/state-master.component';
import { SearchStateMasterComponent } from './state-master/search-state-master/search-state-master.component';
import { SearchCountryMasterComponent } from './country-master/search-country-master/search-country-master.component';
import { SearchCityMasterComponent } from './city-master/search-city-master/search-city-master.component';
import { SearchIpdPatientLocationComponent } from './ipd-patient-location-master/search-ipd-patient-location/search-ipd-patient-location.component';
import { IpdPatientLocationMasterComponent } from './ipd-patient-location-master/ipd-patient-location-master.component';
import { AreaMasterComponent } from './area-master/area-master.component';
import { SearchAreaMasterComponent } from './area-master/search-area-master/search-area-master.component';
import { DistrictMasterComponent } from './district-master/district-master.component';
import { SearchDistrictMasterComponent } from './district-master/search-district-master/search-district-master.component';



@NgModule({
  declarations: [
    CityMasterComponent,
    StateMasterComponent,
    CountryMasterComponent,
    SearchStateMasterComponent,
    SearchCountryMasterComponent,
    SearchCityMasterComponent,
    IpdPatientLocationMasterComponent,
    SearchIpdPatientLocationComponent,
    AreaMasterComponent,
    SearchAreaMasterComponent,
    DistrictMasterComponent,
    SearchDistrictMasterComponent
  ],
  imports: [
    WebcamModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    SharedModule,
    MatFormFieldModule,
    LocationMasterRoutingModule,
  ]
})
export class LocationMasterModule { }
